import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid, Typography } from '@mui/material'
import { FileUploaderFormik as FileUploader, TextField } from '@carsys/form'

export const QuestionFormFields: React.FC<{}> = () => {
  const { t } = useTranslation()

  return (
    <Grid container direction='column' spacing={1.5}>
      <Grid item>
        <Typography variant='h5' gutterBottom>
          {t('Contact.QuestionInformation')}
        </Typography>
      </Grid>
      <Grid item>
        <TextField label={t('Contact.question')} multiline rows={5} required name='Question' />
      </Grid>
      <Grid item>
        <FileUploader name='Uploads' multiple PaperComponent={Box} />
      </Grid>
    </Grid>
  )
}
